import React, { useState } from 'react';
import { SxStyle } from '../../../../types';
import Switch from '@mui/material/Switch';
import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { useSnackbar } from 'notistack';
import { useStringsContext } from '../../../../contexts/strings';
import { Comment } from '../types';
import { useSocial } from '../hooks/social';

const styles: SxStyle = {
  switchContainer: {
    height: 24,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
  },
  progress: {
    marginLeft: 1,
  },
};

interface Props {
  comment: Comment;
}

const SocialListCommentToggle = ({ comment }: Props) => {
  const { strings } = useStringsContext();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const { hideComment } = useSocial();

  const onActiveChanged = async (checked: boolean) => {
    try {
      setLoading(true);

      await hideComment(comment.id, !checked);
      comment.isHidden = !checked;

      const message = !checked
        ? strings.messages.commentHiddenSuccess
        : strings.messages.commentShowSuccess;
      enqueueSnackbar(message, {
        variant: 'success',
      });
    } catch (error: any) {
      console.error(error);

      enqueueSnackbar(strings.messages.saveError, {
        variant: 'error',
      });
    } finally {
      // Slight delay to make the loading spinner look a bit nicer
      setTimeout(() => setLoading(false), 500);
    }
  };

  return (
    <Box sx={styles.switchContainer}>
      {loading ? (
        <CircularProgress size={24} sx={styles.progress} />
      ) : (
        <Switch
          size="small"
          checked={!comment.isHidden || false}
          onChange={(event, checked) => {
            onActiveChanged(checked);
          }}
        />
      )}
    </Box>
  );
};

export default SocialListCommentToggle;
